import React, { createContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const PermissionContext = createContext(null);

export const PermissionProvider = ({ children }) => {
    const currentUser = JSON.parse(localStorage.getItem('userInfo'));
    const [userRole, setUserRole] = useState();
    const [loading, setLoading] = useState(true);
    
    const currentWorkspace = useSelector((state) => state.workspace.workspaceInfo);
    
    useEffect(() => {
        if (currentWorkspace?.data?.user_details && currentUser?._id) {
            const userDetails = currentWorkspace.data.user_details.find(
                user => user._id === currentUser._id
            );
            setUserRole(userDetails?.role?.role);
            setLoading(false);
        }
    }, [currentWorkspace, currentUser]);

    const hasPermission = (requiredRole) => {
        const roleHierarchy = {
            admin: 3,
            editor: 2,
            viewer: 1
        };
        
        const currentRoleLevel = roleHierarchy[userRole] || 1;
        const requiredRoleLevel = roleHierarchy[requiredRole] || 1;
        
        return currentRoleLevel >= requiredRoleLevel;
    };

    return (
        <PermissionContext.Provider value={{ 
            userRole, 
            hasPermission,
            isAdmin: userRole === 'admin',
            isEditor: userRole === 'editor' || userRole === 'admin',
            isViewer: true,
            loading
        }}>
            {children}
        </PermissionContext.Provider>
    );
};